import { UseQueryOptions, useQuery } from 'react-query';
import client from 'client';
import { RingSettings } from './type';

const fetchRingSettings = async (eventId: number, accountId: number) => {
    const { data } = await client().get<RingSettings[]>(
        `/api/v1/ring/accounts/${accountId}/events/${eventId}/rings`
    );
    return data?.[0] || {};
};

const useRingSettings = (eventId: number, accountId: number, options?: UseQueryOptions) => {
    return useQuery<RingSettings, Error>(
        ['ringSettings', eventId, accountId],
        () => fetchRingSettings(eventId, accountId),
        { cacheTime: Infinity, ...options }
    );
};

export default useRingSettings;
